import "svelte/internal/disclose-version";
import * as e from "svelte/internal/client";
var N = e.from_html("<button><!></button>");
function M(v, t) {
  let a = e.prop(t, "variant", 3, "primary"), i = e.prop(t, "size", 3, "md"), s = e.prop(t, "type", 3, "button"), r = e.prop(t, "disabled", 3, !1), c = e.prop(t, "class", 3, ""), d = e.prop(t, "form", 3, void 0);
  var n = N(), p = e.child(n);
  e.snippet(p, () => t.children ?? e.noop), e.reset(n), e.template_effect(() => {
    e.set_attribute(n, "type", s()), n.disabled = r(), e.set_attribute(n, "form", d()), e.set_class(n, 1, `btn ${a() === "primary" ? "btn-primary" : a() === "secondary" ? "btn-secondary font-bold" : a() === "accent" ? "btn-accent font-bold" : a() === "error" ? "btn-error font-bold" : a() === "outline" ? "btn-outline" : a() === "ghost" ? "btn-ghost" : "btn-neutral"} ${i() === "xs" ? "btn-xs" : i() === "sm" ? "btn-sm" : i() === "lg" ? "btn-lg" : ""} ${c() ?? ""}`);
  }), e.delegated("click", n, function(...l) {
    var o;
    (o = t.onclick) == null || o.apply(this, l);
  }), e.append(v, n);
}
e.delegate(["click"]);
var k = e.from_html("<div><!></div>");
function P(v, t) {
  let a = e.prop(t, "variant", 3, "neutral"), i = e.prop(t, "size", 3, "md"), s = e.prop(t, "class", 3, "");
  var r = k(), c = e.child(r);
  e.snippet(c, () => t.children ?? e.noop), e.reset(r), e.template_effect(() => e.set_class(r, 1, `badge ${a() === "primary" ? "badge-primary" : a() === "secondary" ? "badge-secondary" : a() === "accent" ? "badge-accent" : a() === "success" ? "badge-success" : a() === "warning" ? "badge-warning" : a() === "error" ? "badge-error" : a() === "info" ? "badge-info" : a() === "outline" ? "badge-outline" : a() === "ghost" ? "badge-ghost" : "badge-neutral"} ${i() === "xs" ? "badge-xs" : i() === "sm" ? "badge-sm" : i() === "lg" ? "badge-lg" : ""} ${s() ?? ""}`)), e.append(v, r);
}
var q = e.from_html('<h3 class="card-title text-sm font-bold uppercase tracking-wider text-base-content/50"> </h3>'), C = e.from_html('<p class="text-xs text-base-content/40"> </p>'), S = e.from_html('<div class="card-actions"><!></div>'), j = e.from_html('<div class="flex items-center justify-between"><div class="space-y-1"><!> <!></div> <!></div>'), B = e.from_html('<div><div class="card-body p-6 space-y-4"><!> <div class="text-base-content"><!></div></div></div>');
function Q(v, t) {
  let a = e.prop(t, "title", 3, ""), i = e.prop(t, "subtitle", 3, ""), s = e.prop(t, "class", 3, "");
  var r = B(), c = e.child(r), d = e.child(c);
  {
    var n = (o) => {
      var m = j(), h = e.child(m), y = e.child(h);
      {
        var w = (b) => {
          var f = q(), g = e.child(f, !0);
          e.reset(f), e.template_effect(() => e.set_text(g, a())), e.append(b, f);
        };
        e.if(y, (b) => {
          a() && b(w);
        });
      }
      var _ = e.sibling(y, 2);
      {
        var u = (b) => {
          var f = C(), g = e.child(f, !0);
          e.reset(f), e.template_effect(() => e.set_text(g, i())), e.append(b, f);
        };
        e.if(_, (b) => {
          i() && b(u);
        });
      }
      e.reset(h);
      var x = e.sibling(h, 2);
      {
        var z = (b) => {
          var f = S(), g = e.child(f);
          e.snippet(g, () => t.actions), e.reset(f), e.append(b, f);
        };
        e.if(x, (b) => {
          t.actions && b(z);
        });
      }
      e.reset(m), e.append(o, m);
    };
    e.if(d, (o) => {
      (a() || i() || t.actions) && o(n);
    });
  }
  var p = e.sibling(d, 2), l = e.child(p);
  e.snippet(l, () => t.children ?? e.noop), e.reset(p), e.reset(c), e.reset(r), e.template_effect(() => e.set_class(r, 1, `card bg-base-100 border border-base-300 shadow-xl ${s() ?? ""}`)), e.append(v, r);
}
var O = e.from_html('<div class="absolute top-2 right-12 z-20"><!></div>'), T = e.from_html('<div><input type="checkbox"/> <div class="collapse-title text-xs font-bold text-base-content/95 pr-16 truncate"> </div> <div class="collapse-content space-y-4 pt-4 border-t border-base-300"><!> <!></div></div>');
function R(v, t) {
  let a = e.prop(t, "class", 3, "");
  var i = T(), s = e.sibling(e.child(i), 2), r = e.child(s, !0);
  e.reset(s);
  var c = e.sibling(s, 2), d = e.child(c);
  {
    var n = (l) => {
      var o = O(), m = e.child(o);
      e.snippet(m, () => t.actions), e.reset(o), e.append(l, o);
    };
    e.if(d, (l) => {
      t.actions && l(n);
    });
  }
  var p = e.sibling(d, 2);
  e.snippet(p, () => t.children ?? e.noop), e.reset(c), e.reset(i), e.template_effect(() => {
    e.set_class(i, 1, `collapse collapse-arrow border border-base-300 bg-base-200 rounded-xl relative ${a() ?? ""}`), e.set_text(r, t.title);
  }), e.append(v, i);
}
var I = e.from_html("<input/>");
function U(v, t) {
  e.push(t, !0);
  let a = e.prop(t, "type", 3, "text"), i = e.prop(t, "placeholder", 3, ""), s = e.prop(t, "value", 15, ""), r = e.prop(t, "id", 3, ""), c = e.prop(t, "class", 3, ""), d = e.prop(t, "disabled", 3, !1), n = e.prop(t, "required", 3, !1), p = e.prop(t, "readonly", 3, !1), l = e.prop(t, "size", 3, "md");
  var o = I();
  e.remove_input_defaults(o), e.template_effect(() => {
    e.set_attribute(o, "type", a()), e.set_attribute(o, "id", r()), e.set_attribute(o, "placeholder", i()), o.disabled = d(), o.required = n(), o.readOnly = p(), e.set_class(o, 1, `input input-bordered w-full bg-base-200 text-base-content border-base-300 focus:border-accent focus:outline-none transition-colors ${l() === "xs" ? "input-xs" : l() === "sm" ? "input-sm" : l() === "lg" ? "input-lg" : ""} ${c() ?? ""}`);
  }), e.bind_value(o, s), e.append(v, o), e.pop();
}
var A = e.from_html("<!>", 1), D = e.from_html("<select><!></select>");
function V(v, t) {
  e.push(t, !0);
  let a = e.prop(t, "value", 15, ""), i = e.prop(t, "id", 3, ""), s = e.prop(t, "class", 3, ""), r = e.prop(t, "disabled", 3, !1), c = e.prop(t, "size", 3, "md");
  var d = D();
  e.customizable_select(d, () => {
    var n = e.child(d), p = A(), l = e.first_child(p);
    e.snippet(l, () => t.children ?? e.noop), e.append(n, p);
  }), e.template_effect(() => {
    e.set_attribute(d, "id", i()), d.disabled = r(), e.set_class(d, 1, `select select-bordered w-full bg-base-200 text-base-content/80 border-base-300 focus:border-accent focus:outline-none transition-colors ${c() === "xs" ? "select-xs" : c() === "sm" ? "select-sm" : c() === "lg" ? "select-lg" : ""} ${s() ?? ""}`);
  }), e.bind_select_value(d, a), e.append(v, d), e.pop();
}
var E = e.from_html("<div></div>");
function W(v, t) {
  let a = e.prop(t, "height", 3, "h-4"), i = e.prop(t, "width", 3, "w-full"), s = e.prop(t, "class", 3, "");
  var r = E();
  e.template_effect(() => e.set_class(r, 1, `skeleton bg-base-200/50 rounded-xl ${a() ?? ""} ${i() ?? ""} ${s() ?? ""}`)), e.append(v, r);
}
var F = e.from_html('<p class="text-xs text-base-content/40 font-medium"> </p>'), G = e.from_html("<div><!></div>"), H = e.from_html('<div><div class="card-body p-6 flex flex-row items-center justify-between"><div class="space-y-1"><p class="text-xs font-semibold text-base-content/50 uppercase tracking-wider"> </p> <h3 class="text-3xl font-extrabold tracking-tight text-base-content"> </h3> <!></div> <!></div></div>');
function X(v, t) {
  let a = e.prop(t, "desc", 3, ""), i = e.prop(t, "iconColor", 3, "text-accent"), s = e.prop(t, "class", 3, "");
  var r = H(), c = e.child(r), d = e.child(c), n = e.child(d), p = e.child(n, !0);
  e.reset(n);
  var l = e.sibling(n, 2), o = e.child(l, !0);
  e.reset(l);
  var m = e.sibling(l, 2);
  {
    var h = (_) => {
      var u = F(), x = e.child(u, !0);
      e.reset(u), e.template_effect(() => e.set_text(x, a())), e.append(_, u);
    };
    e.if(m, (_) => {
      a() && _(h);
    });
  }
  e.reset(d);
  var y = e.sibling(d, 2);
  {
    var w = (_) => {
      var u = G(), x = e.child(u);
      e.snippet(x, () => t.icon), e.reset(u), e.template_effect(() => e.set_class(u, 1, `p-3 bg-base-200/50 rounded-xl ${i() ?? ""}`)), e.append(_, u);
    };
    e.if(y, (_) => {
      t.icon && _(w);
    });
  }
  e.reset(c), e.reset(r), e.template_effect(() => {
    e.set_class(r, 1, `card bg-base-100 border border-base-300 shadow-xl overflow-hidden ${s() ?? ""}`), e.set_text(p, t.title), e.set_text(o, t.value);
  }), e.append(v, r);
}
var J = e.from_html("<textarea></textarea>");
function Y(v, t) {
  e.push(t, !0);
  let a = e.prop(t, "placeholder", 3, ""), i = e.prop(t, "value", 15, ""), s = e.prop(t, "id", 3, ""), r = e.prop(t, "rows", 3, 3), c = e.prop(t, "class", 3, ""), d = e.prop(t, "disabled", 3, !1), n = e.prop(t, "required", 3, !1), p = e.prop(t, "readonly", 3, !1);
  var l = J();
  e.remove_textarea_child(l), e.template_effect(() => {
    e.set_attribute(l, "id", s()), e.set_attribute(l, "placeholder", a()), e.set_attribute(l, "rows", r()), l.disabled = d(), l.required = n(), l.readOnly = p(), e.set_class(l, 1, `textarea textarea-bordered w-full bg-base-200 text-base-content border-base-300 focus:border-accent focus:outline-none text-sm transition-colors ${c() ?? ""}`);
  }), e.bind_value(l, i), e.append(v, l), e.pop();
}
var K = e.from_html("<div><!></div>");
function Z(v, t) {
  let a = e.prop(t, "position", 3, "top"), i = e.prop(t, "class", 3, "");
  var s = K(), r = e.child(s);
  e.snippet(r, () => t.children ?? e.noop), e.reset(s), e.template_effect(() => {
    e.set_class(s, 1, `tooltip ${a() === "bottom" ? "tooltip-bottom" : a() === "left" ? "tooltip-left" : a() === "right" ? "tooltip-right" : "tooltip-top"} ${i() ?? ""}`), e.set_attribute(s, "data-tip", t.tip);
  }), e.append(v, s);
}
export {
  P as Badge,
  M as Button,
  Q as Card,
  R as Collapse,
  U as Input,
  V as Select,
  W as Skeleton,
  X as StatCard,
  Y as Textarea,
  Z as Tooltip
};
